import React, { Component, Fragment } from 'react';

import { ContentEditor } from 'components/editor';
import InputGroup from 'components/input/group/InputGroup';
import { InputToggle } from 'components/input/toggle';
import { Loader } from 'components/loader';
import { I18n } from 'components/translate';
import { inject, PropTypes as MobxPropTypes, observer } from 'mobx-react';
import { ContentBasePage } from 'modules/content';
import { UiService } from 'modules/ui';
import { PropTypes } from 'prop-types';

import { FormControl, Form } from '../../../components/form';
import ConfigService from '../ConfigService';

import './ConfigHelp.scss';

@inject('ConfigStore')
@observer
export default class ConfigHelp extends Component {
  static propTypes = {
    ConfigStore: MobxPropTypes.objectOrObservableObject,
    fixedBarId: PropTypes.string
  };

  helpForm = React.createRef();

  state = {
    loading: false
  };

  componentDidMount() {
    this.getData();
  }

  setLoading = () => {
    this.setState({ loading: true });
  };

  removeLoading() {
    this.setState({ loading: false });
  }

  toggleLoading = () => {
    this.setState({ loading: !this.state.loading });
  };

  getData() {
    this.setLoading();

    try {
      ConfigService.fetchHelpData();
    } catch (error) {
      UiService.setAlertError('error_try_again');
    } finally {
      this.removeLoading();
    }
  }

  saveConfig = () => {
    this.helpForm.current.submit();
  };

  removeAlphaCaracter(string) {
    return string ? string.replace(/\D/g, '') : null;
  }

  onSubmitForm = async (data) => {
    if (data) {
      this.setLoading();

      data.supportPhone = this.removeAlphaCaracter(data.supportPhone);
      ConfigService.setHelpData(data);

      await ConfigService.updateHelpData(data);

      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      UiService.smoothScroll('.tabs', 500);
      this.removeLoading();
    }
  };

  render() {
    const helpToggleId = 'showHelpPage';
    const { showHelpPage, supportEmail, supportPhone, helpContent } =
      this.props.ConfigStore.help;
    const { loading } = this.state;

    return (
      <Fragment>
        {!loading ? (
          <Form ref={this.helpForm} onSubmit={this.onSubmitForm}>
            <div
              className="grid grid__block"
              data-test="settings-help-information"
            >
              <h2>
                <I18n label="general.informations" />
              </h2>

              <label className="label__subtitle mb__md">
                <I18n label="config_manager.config_help.informations" />
              </label>

              <FormControl>
                <InputGroup
                  name="supportEmail"
                  value={supportEmail}
                  maxLength="100"
                  autoComplete="off"
                  labelValue="config_manager.config_help.suport_mail"
                  placeholder="general.insert_mail"
                  data-test="setting-help-email"
                />
              </FormControl>

              <FormControl>
                <InputGroup
                  name="supportPhone"
                  value={supportPhone}
                  maxLength="100"
                  autoComplete="off"
                  labelValue="config_manager.config_help.suport_phone"
                  placeholder="general.insert_phone"
                  data-test="setting-help-phone"
                />
              </FormControl>

              <label>
                <I18n label="config_manager.config_help.help_page" />
              </label>
              <FormControl>
                <InputToggle
                  id={helpToggleId}
                  key={helpToggleId}
                  name={helpToggleId}
                  value={showHelpPage}
                  labelClass="secondary"
                  labelValue="config_manager.config_help.show_help_page"
                />
              </FormControl>

              <label>
                <I18n label="general.content" />
              </label>
              <FormControl>
                <ContentEditor
                  name="helpContent"
                  value={helpContent || ''}
                  placeholder="general.editor_placeholder"
                  data-test="setting-help-content"
                />
              </FormControl>
            </div>

            <ContentBasePage.Footer onlySave />
          </Form>
        ) : (
          <Loader className="loader__mask-inside-tab" key="loader" mask />
        )}
      </Fragment>
    );
  }
}
